export default [
  {
    path: '/tijianyuyue',
    meta: { title: '体检预约' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/tijianyuyue')
  },
  {
    path: '/yuyuejilu',
    meta: { title: '预约记录' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/yuyuejilu')
  },
  {
    path: '/tijianren',
    meta: { title: '体检人信息' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/tijianren')
  },
  {
    path: '/tijianrenAdd',
    meta: { title: '体检人信息' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/tijianrenAdd')
  },
  {
    path: '/tijianbaogao',
    meta: { title: '体检报告' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/tijianbaogao')
  },
  {
    path: '/tijianbaogaoDetails',
    meta: { title: '报告详情' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/tijianbaogaoDetails')
  },
  {
    path: '/packageDetails',
    meta: { title: '体检预约' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/packageDetails')
  },
  {
    path: '/confirmInformation',
    meta: { title: '体检预约' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/confirmInformation')
  },
  {
    path: '/tijianOrderPay',
    meta: { title: '订单信息' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/tijianOrderPay')
  },
  {
    path: '/appointmentSuccessful',
    meta: { title: '体检预约' },
    component: () => import(/* webpackChunkName: "tijian" */ '../views/tijian/appointmentSuccessful')
  }
]
